<template>
  <!-- 分账审核 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='approvalSubAccountList-1'
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #sourceList>
              <page-source-select
                title="归属业务"
                :sources="queryForm.sourceList"
                @select-change="sourceChange"
              />
            </template>
          </page-select-groups>
          <div class="fan-search-col fan-search-right">
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <div style="margin-left: 10px" v-if="$has('FWS-KJSH-FZSH-DC')">
              <page-export-button
                title="分帐审核数据导出"
                button-text="导出"
                exportServe="fin_receipt_divideApprovalReport"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
                trackCode='approvalSubAccountList-3'
              />
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="subAccountListRef"
        >
          <template v-slot:orderNumber="{ row }">
            <jr-tooltip
              :content="row.orderNumber"
              type="popover"
              :is-filter="true"
            />
          </template>
          <template v-slot:opt="{ row }">
            <btns-operate
              :current="row"
              @success="getList"
            />
          </template>
        </jr-table>
      </template>

      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>

    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :divide-no.sync="detailObj.divideNo"
      @refresh="getList"
    />

    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode='approvalSubAccountList-2'
    />
  </div>
</template>

<script>
import { getDivideBopList } from '@/api/receivables/sub-account';
import detail from './components/detail';
import { setStatusColor } from '@/filters/index';
import BtnsOperate from './components/btns-operate';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '1',
  approvalStatus: '', // 审核状态
  timeType: '1',
  transType: 2,
  sourceList: [],
};

export default {
  name: 'ApprovalSubAccountList',
  components: { detail, BtnsOperate },
  data() {
    const list = [
      { value: '1', label: '业务订单编号' },
      { value: '2', label: '分账申请单编号' },
      { value: '3', label: '分账单编号' },
      { value: '4', label: '客户编号' },
      { value: '5', label: '分账单编号' },
      { value: '6', label: '业务主体' },
    ];
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '审核时间', value: '3' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [...list],
        },

      ],
      tableColumn: [
        {
          prop: 'divideApplyNo',
          label: '分账申请单编号',
          minWidth: '1',
          disabled: true,
          permission: 'FWS-KJSH-FZSH-XQ',
          trackCode: 'approvalSubAccountList-4',
          click: (row) => {
            this.handleDetail(row);
          },
        },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1', slotName: 'orderNumber' },
        { prop: 'divideAmount', label: '分账金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { label: '归属业务', prop: 'busiSourceDesc', minWidth: '1' },
        { prop: 'createTime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        { prop: 'createUser', label: '分账申请人', minWidth: '1' },
        {
          label: '审核状态',
          prop: 'approvalStatus',
          status: 'approvalStatus',
          statusDesc: 'approvalStatusDesc',
          statusColor: (val) => setStatusColor(val, 'subStatus'),
        },
        { prop: 'approvalUser', label: '操作人', minWidth: '1' },
        { prop: 'operate', label: '操作', slotName: 'opt', width: '165px', disabled: true },
      ],
      isDetailShow: false, // 详情弹窗
      detailObj: {}, // 当前付款信息
      /** ------批量搜索---- */
      batchSearchTypeList: [ // 批量搜索搜索条件集合
        ...list,
      ],
      isBatchSearchShow: false, // 批量搜索
      batchResults: {}, // 批量操作返回结果
      /** ------批量操作---- */
      // 批量操作合并信息
      multipleSelection: [], // 选中的数据
      selectTableColumn: [],
      // 推荐字段
      recommendedColumn: [
        { label: '审核时间', prop: 'approvalTime', filterName: 'formatTime' },
        { label: '驳回原因', prop: 'rejectReason', showOverflowTooltip: true },
      ],
      columnsKey: 'fwsSubAccountList',
      selectList: [
        {
          title: '审核状态',
          prop: 'approvalStatus',
          dictionaryPath: '/finance/finance-receipt/DivideApprovalStatusEnum',
        },
        {
          slotName: 'sourceList',
        },
      ],
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { approvalStatus } = this.$route.query;
      this.queryForm.approvalStatus = approvalStatus || '';
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.subAccountListRef.doLayout();
      });
    },
    // 多选选择返回结果
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量确认多选限制设置
    setDisabled(row) {
      if ([1, '1'].includes(row.approvalStatus)) {
        return 1;
      }
      return 0;
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      this.batchResults = form;
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.searchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 详情
    handleDetail(row = {}) {
      this.detailObj = { ...row };
      this.isDetailShow = true;
    },

    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },

    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表查询
    async getList() {
      try {
        this.loading = true;
        this.list = [];
        const res = await getDivideBopList({ ...this.queryForm });
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    sourceChange(list) {
      this.queryForm.sourceList = [...list];
      this.refreshList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
  },
};
</script>
